import { css, jsx } from '@emotion/core';
import { Checkbox } from 'antd';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { handleFormChange } from '@/src/updateProfile/redux/actions';

// import { setInputFieldInfo, toggleCheckbox } from '@/src/updateProfile/redux/updateProfileActions';
import Label from './Label';

const styles = {
  checkboxInfoContainer: css`
    max-width: 36.5rem;
    width: 100%;
    margin: 1.6rem 0;
  `,
  checkboxLabelText: css`
    font-size: 1.2rem;
    font-weight: 900;
    margin-left: 8px;
  `,
};

const APCIACheckbox = props => {
  const {
    form,
    info,
    step,
    isToggled,
    updateProfile: { isMailingAddressDisabled },
  } = props;

  const onChange = e => {
    const {
      target: { checked },
    } = e;

    if (checked) {
      props.handleFormChange('isMailingAddressDisabled', true);
      form.setFieldsValue({
        PoBoxNumber: '',
        PoBoxCity: '',
        PoBoxStateCode: '',
        PoBoxState: '',
        PoBoxPostalCode: '',
      });
    } else {
      props.handleFormChange('isMailingAddressDisabled', false);
    }
  };

  useEffect(() => {
    if (isMailingAddressDisabled) {
      form.validateFields(['PoBoxNumber', 'PoBoxCity', 'PoBoxStateCode', 'PoBoxPostalCode'], {
        force: true,
      });
    }
  }, [isMailingAddressDisabled]);

  const { checkboxLabel } = info;
  return (
    <div css={styles.checkboxInfoContainer}>
      <Label info={info} />
      <div>
        <Checkbox onChange={e => onChange(e)} checked={isMailingAddressDisabled} />
        <span css={styles.checkboxLabelText}>{checkboxLabel}</span>
      </div>
    </div>
  );
};

const mapStateToProps = ({ updateProfile }) => {
  return {
    updateProfile,
  };
};

const mapDispatchToProps = {
  handleFormChange,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(APCIACheckbox);
